import Immutable from 'immutable';
import { createSelector } from 'reselect';

const getPreview = state => state.get('preview', Immutable.Map());

export const selectPreviewFeatures = createSelector([getPreview], preview =>
  preview.get('previewFeatures', Immutable.Map())
);

export const selectPreviewTransactions = createSelector([getPreview], preview =>
  preview.get('previewTransactions', Immutable.Map())
);

export default {
  selectPreviewFeatures,
  selectPreviewTransactions
};
